const characterId = (character) => String(character?.id ?? character?.characterId ?? '');

const characterName = (character) => String(character?.name ?? character?.characterName ?? '').trim();

const shuffleInPlace = (items, random = Math.random) => {
    const list = Array.isArray(items) ? items : [];
    for (let i = list.length - 1; i > 0; i -= 1) {
        const j = Math.floor(random() * (i + 1));
        const swap = list[i];
        list[i] = list[j];
        list[j] = swap;
    }
    return list;
};

const getMentionedCharacters = (message, characters = []) => {
    const text = typeof message === 'string' ? message : '';
    const roster = Array.isArray(characters) ? characters : [];
    const hits = [];
    for (const character of roster) {
        const name = characterName(character);
        if (!name) continue;
        const index = text.indexOf(`@${name}`);
        if (index === -1) continue;
        hits.push({ character, index, nameLength: name.length });
    }
    hits.sort((a, b) => a.index - b.index || b.nameLength - a.nameLength);
    const claimedIndexes = new Set();
    const seen = new Set();
    const ordered = [];
    for (const hit of hits) {
        if (claimedIndexes.has(hit.index)) continue;
        const id = characterId(hit.character);
        if (!id || seen.has(id)) continue;
        claimedIndexes.add(hit.index);
        seen.add(id);
        ordered.push(hit.character);
    }
    return ordered;
};

export const orderRespondingCharacters = (message, respondingCharacters = [], { random = Math.random } = {}) => {
    const responders = Array.isArray(respondingCharacters) ? [...respondingCharacters] : [];
    if (responders.length <= 1) return responders;
    const mentioned = getMentionedCharacters(message, responders);
    const mentionedIds = new Set(mentioned.map(characterId).filter(Boolean));
    const rest = responders.filter((character) => !mentionedIds.has(characterId(character)));
    shuffleInPlace(rest, random);
    return [...mentioned, ...rest];
};

const normalizeSpeakingOrderIds = (requestedIds = []) => {
    if (!Array.isArray(requestedIds)) return [];
    const seen = new Set();
    const ids = [];
    for (const raw of requestedIds) {
        if (raw == null) continue;
        const id = String(raw).trim();
        if (!id || seen.has(id)) continue;
        seen.add(id);
        ids.push(id);
    }
    return ids;
};

const resolveSpeakingOrder = (
    message,
    respondingCharacters = [],
    requestedIds = null,
    { random = Math.random } = {}
) => {
    const responders = Array.isArray(respondingCharacters) ? [...respondingCharacters] : [];
    if (responders.length <= 1) return responders;
    const byId = new Map();
    for (const character of responders) {
        const id = characterId(character);
        if (id && !byId.has(id)) byId.set(id, character);
    }
    const requested = [];
    const seen = new Set();
    for (const id of normalizeSpeakingOrderIds(requestedIds)) {
        if (!byId.has(id) || seen.has(id)) continue;
        seen.add(id);
        requested.push(byId.get(id));
    }
    const missing = responders.filter((character) => !seen.has(characterId(character)));
    if (requested.length === 0) return orderRespondingCharacters(message, responders, { random });
    shuffleInPlace(missing, random);
    return [...requested, ...missing];
};
